export default __webpack_public_path__ + "static/media/25l-inact.5f1ca7c2.svg";